<template>
  <div class="">
    <child/>
  </div>
</template>

<script>
export default {
  name: 'PrintLayout'
}
</script>
